module.exports = __webpack_public_path__ + "static/img/zt3.a87e3e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/zt3.png
// module id = 307
// module chunks = 34